export class StudyStatusDialog {

    statusList: {Id: number, Name: string}[];
    siteStudyId: number;

    successCallback: (response) => void;

    constructor(statusList) {
        this.statusList = statusList;

        this.initialize();
    }

    initialize() {
        const options = this.statusList.map((s) => new Option(s.Name, s.Id.toString()));

        $('#StatusNewStatus').append(options);

        $('#editStatusDialog .ctms-button-save').on('click', this.saveDialog.bind(this));
    }

    resetDialog(siteStudyId, statusId, studyName) {
        this.siteStudyId = siteStudyId;
        $('#StatusNewStatus').val(statusId);
        $('#StatusStudy').text(studyName);
        $('#SiteStudyId').val(siteStudyId);

        $('#StatusChangeDate').val(new Date().toISOString().split('T')[0]);
    }

    saveDialog(evt: JQuery.ClickEvent) {
        const token = document.querySelector('input[name="__RequestVerificationToken"]').getAttribute('value');

        $.ajax({
            url: `/secure/ctms/sites/site-details?handler=UpdateStudyStatus`,
            headers: { "RequestVerificationToken": token },
            type: 'POST',
            data: $('#studyStatusForm .ctms-field-submit').serialize(),
            success: (resp) => {
                if (this.successCallback) this.successCallback(resp);
                $('#editStatusDialog').modal('hide');
            }
        });

        evt.preventDefault();
        evt.stopPropagation();
    }


}